export default __webpack_public_path__ + "static/media/about.d1840ac2.png";